import { Splide } from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import '@splidejs/splide/dist/css/splide.min.css'

const sponsors = document.querySelector('.splide')

const fn = {
  init: () => {
    new Splide('.splide', {
      perPage: 5,
      perMove: 1,
      type: 'loop',
      arrows: false,
      gap: '2rem',
      pagination: false,
      autoWidth: true,
      easing: 'linear',
      autoScroll: {
        speed: 0.6,
      },
      breakpoints: {
        1250: {
          gap: '10px',
        },
      },
    }).mount({ AutoScroll })
  },
}

export default {
  can: () => sponsors,
  run: fn.init,
}
